import React from 'react'
import { createPortal } from 'react-dom'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'

interface PortalCreatorProps {
  portalName: string
  children?: React.ReactNode
}

const ContentWrapper = styled.div`
  position: fixed;
  z-index: ${constants.zIndexModalOverlay};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  pointer-events: none;
`

export class PortalCreator extends React.Component<PortalCreatorProps> {
  portal: HTMLDivElement

  constructor(props: PortalCreatorProps) {
    super(props)
    this.portal = document.createElement('div')
  }

  componentDidMount() {
    this.portal.className = this.props.portalName
    document.body.appendChild(this.portal)
  }

  render() {
    return createPortal(<ContentWrapper>{this.props.children}</ContentWrapper>, this.portal)
  }
}
